(function () {
window.onpageshow = function() {          
    if (window.theme.showPageTransition) {
    var pageTransition = document.querySelector('.PageTransition');

    if (pageTransition) {
        pageTransition.style.visibility = 'visible';
        pageTransition.style.opacity = '0';
    }
    }

    // When the page is loaded from the cache, we have to reload the cart content
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true
    }));
};
})();